import { render, staticRenderFns } from "./GestionaTuDeuda.vue?vue&type=template&id=0672c122&"
import script from "./GestionaTuDeuda.vue?vue&type=script&lang=ts&"
export * from "./GestionaTuDeuda.vue?vue&type=script&lang=ts&"
import style0 from "./GestionaTuDeuda.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports